import { render, staticRenderFns } from "./btn-quarternary.vue?vue&type=template&id=ef901f62&scoped=true"
import script from "./btn-quarternary.vue?vue&type=script&lang=js"
export * from "./btn-quarternary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef901f62",
  null
  
)

export default component.exports